import React from 'react'

import { bleedTwo } from '../_media'
import DeviceBadges from './DeviceBadges'
import HalfBleed from '../HalfBleed'

const Devices = ({ ...rest }) => (
  <HalfBleed
    images={bleedTwo}
    headline='World-Class Wellness. Wherever You Are.'
    body='Take your favorite classes at home, while traveling, or outdoors. Download classes on the app for a practice that moves with you.'
    rightAlign
    {...rest}
  >
    <DeviceBadges />
  </HalfBleed>
)

export default Devices
